<template>
  <!-- Header -->
  <header class="header">
    <div class="header__wrapper">
      <div class="header__wrapper__item">
        <router-link to="/" class="logo">
          <img :src="logo" alt="Jai Jinendra Trust" width="60" class="float--left" />
          <span class="logo-text">
            {{ $t("header.jai") }} <span>{{ $t("header.jinendra") }}</span>
          </span>
        </router-link>
        <span class="logo-subtext">{{ $t("header.logoSubText") }}</span>
      </div>
      <div class="header__wrapper__item">
        <p class="header__wrapper__item--col">
          <i aria-hidden="true" class="icon icon-mail5"></i>
          {{ $t("header.emialUsAt") }}
          <a href="mailto:jaijinendratrust@gmail.com"> {{ headerEmail }} </a>
        </p>
      </div>
      <div class="header__wrapper__item">
        <p class="header__wrapper__item--col">
          <i aria-hidden="true" class="icon icon-phone2"></i>
          {{ $t("header.callUsNow") }}
          <span class="dispay--block">{{ headerContactNumber }}</span>
        </p>
      </div>
      <div class="header__wrapper__item text--right">
        <p class="header__wrapper__item--col">
          <a :href="paymentLink" class="button button--primary btn-donate" target="_blank" rel="noopener">
            {{ $t("button.donateNow") }}
          </a>
        </p>
      </div>
    </div>
  </header>
</template>

<script>
import { constants } from "@/lib/constants";

export default {
  name: "Header",
  data() {
    return {
      logo: constants.imagePath + "jaijinendratrust-logo.png",
      headerContactNumber: constants.headerContactNumber,
      headerEmail: constants.headerEmail,
      paymentLink: constants.paymentLink
    };
  }
};
</script>
